import { Flex } from "antd";
import { DataTableImageColumn } from "~components/DataTable/components/DataTableImageColumn/DataTableImageColumn.tsx";
import { CompetitorTypes } from "~enums/competitorTypes";
import { ImageTypes } from "~enums/imageTypes";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import type { Image } from "~types/image";

type Props = {
  entrant: { nameFullLocal: string; images: Image[]; id: string };
  isHome?: boolean;
};

const EntrantColumn = ({ entrant, isHome }: Props) => {
  const { competitorType } = useSportConfiguration();
  let imageTypes = [ImageTypes.Logo, ImageTypes.LogoAlternate];
  if (competitorType === CompetitorTypes.Entity) {
  }
  if (competitorType === CompetitorTypes.Person) {
    imageTypes = [ImageTypes.PersonHead];
  }

  return (
    <Flex gap={4} align="center" justify="center">
      {!isHome && <DataTableImageColumn images={entrant?.images} imageTypes={imageTypes} />}
      <span>{entrant?.nameFullLocal}</span>
      {isHome && <DataTableImageColumn images={entrant?.images} imageTypes={imageTypes} />}
    </Flex>
  );
};

export default EntrantColumn;
